import {Injectable} from '@angular/core';
import {StorageService} from "./storage.service";
import axios from 'axios';
import {environment} from "../../environments/environment";
import {Router} from "@angular/router";

const instance = axios.create();

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    apiUrl = '';
    token = '';
    lang = '';

    /**
     * Constructs
     * @param storageService
     * @param router
     */
    constructor(
        private storageService: StorageService,
        private router: Router,
    ) {
        this.apiUrl = environment.apiUrl;
    }

    /**
     * Do Request Function for API
     * @param url
     * @param method
     * @param data
     * @param ignoreAuth
     */
    async doRequest(url: string, method: string, data: {}, ignoreAuth = false) {
        let resp;

        this.token = await this.storageService.get('token')
        this.lang = await this.storageService.get('lang')

        if (method === 'GET' || method === "DELETE") {
            url = url + "?" + this.setUrlParams(data);
        }

        let headers : any = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Accept-Language' : this.lang || 'en'
        }

        if(this.token !== null) {
            headers['Authorization'] = 'Bearer ' + this.token;
        }

        const HeaderOptions = { headers: headers }

        switch (method) {
            case 'POST':
            case 'PATCH':
            case 'PUT':
                // @ts-ignore
                resp = instance[method.toLowerCase()](this.apiUrl + url, data, HeaderOptions)
                break;
            case 'GET':
            case 'DELETE':
                // @ts-ignore
                resp = instance[method.toLowerCase()](this.apiUrl + url, HeaderOptions)
                break;
        }

        resp.catch((e: any) => {
            if (!e.hasOwnProperty('response')) {
                return;
            }

            if (!e.response.hasOwnProperty('status')) {
                return;
            }

            if (e.response.status === 401 && url !== 'status?') {
                this.storageService.remove('token');
                if (this.router.url !== '/login') {
                    this.router.navigateByUrl('/login');
                }
            }

        })

        return resp;

    }

    async download(url: string, accept = 'text/plain') {
        this.token = await this.storageService.get('token');
        this.lang  = await this.storageService.get('lang');

        const headers: any = {
            'Accept': accept,
            'Accept-Language': this.lang || 'en',
            'Authorization' :  'Bearer ' + this.token
        };

        return instance.get(this.apiUrl + url, {
            headers,
            responseType: 'blob',
        });
    }

    /**
     * Set Params for Get Request
     * @param params
     */
    setUrlParams(params: any) {
        let _params: any = [];

        Object.keys(params).forEach(key => {
            _params.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        });

        return _params.join("&")
    }
}
